'use strict';

/**
 * Get address fields for country
 *
 * When given the meta information on the address fields, different
 * address fields can be dynamically built up using include / exclude settings.
 *
 */
const countries = {
	all: 'All',
	china: 'China'
};

const metaConfig = {
	street: { include: [countries.all] },
	zip: { include: [countries.all] },
	city: { include: [countries.all] },
	state: { include: [countries.all], exclude: [countries.china] },
	country: { include: [countries.all] },
	// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
	countryAlpha2Code: { include: [countries.all] },
	province: { include: [countries.china] },
	district: { include: [countries.china] }
};

const getAddressFieldsForCountry = country => {
	const tryDo = (f, x) => {
		try {
			return f(x);
		} catch (err) {
			throw Error(`Action failed: ${err.stack},\n\nfor input: ${JSON.stringify(x)}`);
		}
	};
	const exclude = m => tryDo(x => x && x.exclude && x.exclude.includes(country), m);
	const include = m =>
		tryDo(x => x && x.include && (x.include.includes(country) || x.include.includes('All')), m);

	return Object.keys(metaConfig).reduce((acc, field) => {
		const metaInfo = metaConfig[field];
		const shouldBeIncluded = !exclude(metaInfo) && include(metaInfo);
		return [...acc, ...(shouldBeIncluded ? [field] : [])];
	}, []);
};

const mapFieldsForCountry = (addressObject, excludes = []) => {
	if (addressObject?.country) {
		let availableFields = getAddressFieldsForCountry(addressObject.country);
		availableFields = availableFields.filter(m => !excludes.includes(m));

		return availableFields.reduce((acc, field) => {
			if (addressObject[field]) {
				acc[field] = addressObject[field];
			} else {
				acc[field] = '';
			}
			return acc;
		}, {});
	}

	return addressObject;
};

module.exports = {
	getAddressFieldsForCountry,
	mapFieldsForCountry
};
